var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFilterLeftIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5C2.5 10.3674 2.55268 10.2402 2.64645 10.1464C2.74021 10.0527 2.86739 10 3 10H6C6.13261 10 6.25979 10.0527 6.35355 10.1464C6.44732 10.2402 6.5 10.3674 6.5 10.5C6.5 10.6326 6.44732 10.7598 6.35355 10.8536C6.25979 10.9473 6.13261 11 6 11H3C2.86739 11 2.74021 10.9473 2.64645 10.8536C2.55268 10.7598 2.5 10.6326 2.5 10.5ZM2.5 7.5C2.5 7.36739 2.55268 7.24021 2.64645 7.14645C2.74021 7.05268 2.86739 7 3 7H10C10.1326 7 10.2598 7.05268 10.3536 7.14645C10.4473 7.24021 10.5 7.36739 10.5 7.5C10.5 7.63261 10.4473 7.75979 10.3536 7.85355C10.2598 7.94732 10.1326 8 10 8H3C2.86739 8 2.74021 7.94732 2.64645 7.85355C2.55268 7.75979 2.5 7.63261 2.5 7.5ZM2.5 4.5C2.5 4.36739 2.55268 4.24021 2.64645 4.14645C2.74021 4.05268 2.86739 4 3 4H14C14.1326 4 14.2598 4.05268 14.3536 4.14645C14.4473 4.24021 14.5 4.36739 14.5 4.5C14.5 4.63261 14.4473 4.75979 14.3536 4.85355C14.2598 4.94732 14.1326 5 14 5H3C2.86739 5 2.74021 4.94732 2.64645 4.85355C2.55268 4.75979 2.5 4.63261 2.5 4.5Z",
    fill: "#666666"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterLeftIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FilterLeftIcon.787232fe.svg";
export { ForwardRef as ReactComponent };